import { PhoneOutlined } from "@mui/icons-material";
import React from "react";

import useActionTypes from "../../../../../../../hooks/useActionTypes";

import FollowUpViews from "./components/FollowUpViews";

const CaseFollowUps = (caseInfo) => {
  const actionTypes = useActionTypes();

  return (
    <div id="Follow-Ups" data-testid="Follow-Ups">
      <FollowUpViews
        key={"C-Follow-Ups"}
        divId={"C-Follow-Ups"}
        title={"Client Follow Ups"}
        icon={<PhoneOutlined />}
        limit={1}
        actionType={actionTypes?.client?.key}
        actionTypeList={actionTypes}
        caseInfo={caseInfo}
      />
      <FollowUpViews
        key={"LF-Follow-Ups"}
        divId={"LF-Follow-Ups"}
        title={"Law Firm Follow Ups"}
        icon={<PhoneOutlined />}
        limit={1}
        actionType={actionTypes?.law?.key}
        actionTypeList={actionTypes}
        caseInfo={caseInfo}
      />
      <FollowUpViews
        key={"P-Follow-Ups"}
        divId={"P-Follow-Ups"}
        title={"Provider Follow Ups"}
        icon={<PhoneOutlined />}
        limit={null}
        actionType={actionTypes?.provider?.key}
        actionTypeList={actionTypes}
        caseInfo={caseInfo}
      />
    </div>
  );
};

export default CaseFollowUps;
